function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export function isPromise(value) {
  return value.then !== undefined;
}
class ContextActionUtils {
  static disableAllActions() {
    ContextActionUtils.actionsDisabled = true;
  }
  static enableAllActions() {
    ContextActionUtils.actionsDisabled = false;
  }
  static isContextActionEvent(e) {
    return Array.isArray(e.contextActions);
  }

  /**
   * Compare two action items. Useful in Array.sort
   * @param a First context action to compare
   * @param b Second context action to compare
   */
  static compareActions(a, b) {
    if (a.group !== b.group) {
      var _a$group, _b$group;
      return ((_a$group = a.group) !== null && _a$group !== void 0 ? _a$group : 0) > ((_b$group = b.group) !== null && _b$group !== void 0 ? _b$group : 0) ? 1 : -1;
    }
    if (a.order !== b.order) {
      var _a$order, _b$order;
      return ((_a$order = a.order) !== null && _a$order !== void 0 ? _a$order : 0) > ((_b$order = b.order) !== null && _b$order !== void 0 ? _b$order : 0) ? 1 : -1;
    }
    if (a.title !== b.title) {
      var _a$title, _b$title;
      return ((_a$title = a.title) !== null && _a$title !== void 0 ? _a$title : '') > ((_b$title = b.title) !== null && _b$title !== void 0 ? _b$title : '') ? 1 : -1;
    }
    if (a !== b) {
      return a > b ? 1 : -1;
    }
    return 0;
  }

  /**
   *
   * @param actions The array of actions to sort
   */
  static sortActions(actions) {
    if (actions == null || !Array.isArray(actions)) {
      return [];
    }
    var sortedActions = actions.slice();
    sortedActions.sort(ContextActionUtils.compareActions);
    return sortedActions;
  }
  static isMacPlatform() {
    var platform = window.navigator.platform;
    return platform.startsWith('Mac');
  }

  /**
   * Retrieve the preferred modifier key based on the current platform
   */
  static getModifierKey() {
    if (ContextActionUtils.isMacPlatform()) {
      return 'metaKey';
    }
    return 'ctrlKey';
  }

  /**
   * Returns true if the modifier key for the current platform is down for the event (Ctrl for windows/linux, Command (meta) for mac)
   * @param event The event to get the meta key status from
   */
  static isModifierKeyDown(event) {
    var modifierKey = ContextActionUtils.getModifierKey();
    return event[modifierKey];
  }

  /**
   * Returns the menu items for the provided context actions, or empty array if none found.
   * @param actionsParam The actions to get menu items for
   * @param includePromises Whether or not to include promises in the returned menu items
   */

  // If ignoring promises, then the return type is narrowed

  static getMenuItems(actionsParam) {
    var includePromises = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var menuItems = [];
    var actions = actionsParam;
    if (!Array.isArray(actions)) {
      actions = [actions];
    }
    for (var i = 0; i < actions.length; i += 1) {
      var action = actions[i];
      var newMenuItems = void 0;
      if (typeof action === 'function') {
        newMenuItems = action();
      } else {
        newMenuItems = action;
      }
      if (newMenuItems != null) {
        if (newMenuItems instanceof Promise) {
          if (includePromises) {
            menuItems.push(newMenuItems);
          }
        } else if (Array.isArray(newMenuItems)) {
          menuItems = menuItems.concat(newMenuItems);
        } else {
          menuItems.push(newMenuItems);
        }
      }
    }
    menuItems = menuItems.filter(action => action.title !== undefined || action.then != null || action.menuElement);
    return menuItems;
  }

  /**
   * Returns the index of the next menu item in a list that doesn't have a disabled=true prop
   * @param startIndex the starting position for the iteration
   * @param delta the direction of travel, -1 or 1
   * @param menuItems an array of menuItems
   */
  static getNextMenuItem(startIndex, delta, menuItems) {
    var firstIndex = startIndex;
    if (firstIndex < 0 && delta < 0) {
      // if menu index is -1 and delta -1 manually set start point
      firstIndex = menuItems.length;
    }
    // find the next non disabled menu option, iterating the list only once
    for (var i = 1; i < menuItems.length + 1; i += 1) {
      var menuIndex = (firstIndex + delta * i + menuItems.length) % menuItems.length;
      var item = menuItems[menuIndex];
      if (!(item instanceof Promise) && item.disabled !== true) {
        return menuIndex;
      }
    }
    return startIndex;
  }
}
_defineProperty(ContextActionUtils, "actionsDisabled", false);
export default ContextActionUtils;
//# sourceMappingURL=ContextActionUtils.js.map